import api from './api';

export interface OptionResponse {
  success: boolean;
  data?: any;
  message?: string;
}

class OptionService {
  async get(optionName: string, defaultValue?: any): Promise<any> {
    try {
      const response = await api.get<OptionResponse>(`/options/${optionName}`);
      return response.data?.data || defaultValue;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return defaultValue;
      }
      throw error;
    }
  }

  async set(optionName: string, value: any, autoload: string = 'yes'): Promise<boolean> {
    try {
      const response = await api.post<OptionResponse>('/options', {
        option_name: optionName,
        option_value: value,
        autoload
      });
      return response.data?.success || false;
    } catch (error) {
      console.error('Failed to set option:', error);
      throw error;
    }
  }

  async delete(optionName: string): Promise<boolean> {
    try {
      const response = await api.delete<OptionResponse>(`/options/${optionName}`);
      return response.data?.success || false;
    } catch (error) {
      console.error('Failed to delete option:', error);
      throw error;
    }
  }

  async getAll(): Promise<Record<string, any>> {
    try {
      const response = await api.get<OptionResponse>('/options');
      return response.data?.data || {};
    } catch (error) {
      console.error('Failed to get all options:', error);
      throw error;
    }
  }

  async getAutoload(): Promise<Record<string, any>> {
    try {
      const response = await api.get<OptionResponse>('/options/autoload');
      return response.data?.data || {};
    } catch (error) {
      console.error('Failed to get autoload options:', error);
      throw error;
    }
  }
}

export const optionService = new OptionService();
export default optionService;